<template>
  <div
    v-if="content && salle"
    :class="[jel_getClassObject(content)]"
    :data-component-name="$options.name"
    class="bingo_div_height"
  >
    <!-- ****************************** -->
    <!-- ***** PASTILLE (accueil) ***** -->
    <!-- ****************************** -->
    <div v-if="content.typeAffichage.field === 'pastille'" data-component-page="salles.accueil">
      <a
        :class="[isSalleActive ? 'cursor_pointer' : '']"
        @click="[isSalleActive ? launchBingoAndGaq() : '']"
      >
        <div
          class="column"
          :class="[
            isSalleActive
              ? 'ctn-shadow bingo_card_corner bingo_card_background glow_card'
              : 'bingo_card_corner bingo_salle_fermer bingo_card_background',
          ]"
        >
          <!-- Titre -->
          <div v-if="isSalleActive" class="bingo_titre bingo_color pr-4">{{ salle.titre }}</div>
          <div v-else class="bingo_titre bingo_fermer_titre_img bingo_color pr-4">
            {{ salle.titre }}
          </div>

          <div v-if="isSalleActive" class="bingo_div_img_principal">
            <b-card-img-lazy
              :src="jel_getFichierSrc(salle.image)"
              :alt="salle.titre"
              :data-tag="`${jel_getNomRouteCourante()} - ${salle.titre.replace(/&nbsp;/g, ' ')} - ${
                content.dataTag
              }`"
              class="bingo_img_principal"
            ></b-card-img-lazy>
            <div class="position-relative bingo_container_over_price">
              <div class="bingo_container_over graphik_bold">
                <money-format
                  :value="salleLive.prixCarteMin"
                  :locale="$i18n.locale + '-CA'"
                  currency-code="CAD"
                  :subunit-value="true"
                ></money-format>
                <span v-if="salleLive.prixCarteMin != salleLive.prixCarteMax" class="px-1">
                  -
                </span>
                <money-format
                  v-if="salleLive.prixCarteMin != salleLive.prixCarteMax"
                  :value="salleLive.prixCarteMax"
                  :locale="$i18n.locale + '-CA'"
                  currency-code="CAD"
                  :subunit-value="true"
                ></money-format>
              </div>
            </div>
          </div>

          <div v-else class="bingo_div_img_pricipal">
            <!-- Salle fermée -->
            <b-card-img-lazy
              :src="jel_getFichierSrc(salle.image)"
              :alt="salle.titre"
              class="bingo_fermer_titre_img bingo_img_principal"
            ></b-card-img-lazy>
          </div>
          <div class="bingo_pastille_row">
            <template v-if="isSalleActive">
              <div class="row bingo_pastille_row_txt mx-0">
                <div class="column col-7 px-0">
                  <!-- si la salle ne contient pas de lot progressif -->
                  <div
                    v-if="!salleLive.grosLots || salleLive.grosLots.length == 0"
                    class="bingo_color ml-2"
                  >
                    <div class="bingo_progressif bingo_progressif_pastille">
                      {{ $t('messageComponent.aucunProgressif') }}
                    </div>
                  </div>
                  <!--si la salle contient plus d'un progressif -->
                  <div v-else-if="salleLive.grosLots.length >= 1" class="ml-2">
                    <div class="bingo_progressif bingo_progressif_pastille">
                      {{ $t('messageComponent.progressif') }} {{ salleLive.grosLots[0].nom }}
                    </div>
                    <div class="bingo_progressif_lot_accueil graphik_bold">
                      <money-format
                        :value="Number(salleLive.grosLots[0].montant)"
                        :locale="$i18n.locale + '-CA'"
                        currency-code="CAD"
                        :subunit-value="true"
                        :hide-subunits="true"
                        class="bingo_prix bingo_color"
                      ></money-format>
                    </div>
                  </div>
                </div>
                <div class="column col-5"></div>
              </div>
              <div
                class="bingo_pastille_row_footer graphik_bold"
                :style="{ 'background-color': salle.couleurClair }"
              >
                <div class="row bingo_color justify-content-around h-100">
                  <div v-if="isSalleSolo" class="column col-4 bingo_color bingo_icon_wrapper">
                    <img
                      v-lazy="`${mixinEnvironnement_damPath}/jel/bingo/icones/icon_playerSolo.svg`"
                      :alt="$t('messageComponent.nbJoueurs')"
                      class="bingo_icon"
                    />
                    {{ CS_NB_JOUEUR_SOLO }}
                  </div>
                  <div v-else class="column col-4 bingo_color bingo_icon_wrapper">
                    <img
                      v-lazy="`${mixinEnvironnement_damPath}/jel/bingo/icones/icon_player.svg`"
                      :alt="$t('messageComponent.nbJoueurs')"
                      class="bingo_icon"
                    />
                    {{ salleLive.nombreJoueurs }}
                  </div>
                  <div
                    v-if="!isSalleSolo"
                    class="column col-4 bingo_color bingo_clock_icon_wrapper"
                  >
                    <img
                      v-lazy="`${mixinEnvironnement_damPath}/jel/bingo/icones/icon_clock.svg`"
                      :alt="$t('messageComponent.temps')"
                      class="bingo_icon"
                    />
                    <CompteARebours :dateHeureFin="salleLive.debutTirage"></CompteARebours>
                  </div>
                  <div class="column col-4 bingo_color bingo_icon_wrapper">
                    <img
                      v-lazy="`${mixinEnvironnement_damPath}/jel/bingo/icones/icon_balls.svg`"
                      :alt="$t('messageComponent.boules')"
                      class="bingo_icon"
                    />
                    {{ salleLive.nombreBoules }}
                  </div>
                </div>
              </div>
            </template>

            <template v-else>
              <!-- Salle fermée -->
              <div class="bingo_msg_desactivation justify-content-center bingo_color mx-2">
                <div class="graphik_bold">
                  {{ messageTitreSalleDesactivation }}
                </div>
                <div class="detail_message_fermeture">{{ messageSousTitreSalleDesactivation }}</div>
              </div>
              <div
                class="bingo_message_heure_ouverture px-2 w-100"
                :style="{ 'background-color': salle.couleurClair }"
              >
                <div class="bingo_color d-flex justify-content-center align-items-center h-100">
                  {{ messageRetour }}
                  <!-- mis sur UTC peut être changé -->
                </div>
              </div>
            </template>
          </div>
        </div>
      </a>
    </div>

    <!-- ********************** -->
    <!-- ***** Mini-LOBBY ***** -->
    <!-- ********************** -->
    <div
      v-else-if="content.typeAffichage.field === 'lobby'"
      data-component-page="salles.lobby"
      :data-tag="`${jel_getNomRouteCourante()} - ${salle.titre.replace(/&nbsp;/g, ' ')} - ${
        content.dataTag
      }`"
    >
      <div
        v-if="
          (!isSalleCourante &&
            (isSalleActive || content.typeAffichage.forcerAffichage == 'true')) ||
          mixinEnvironnement_inMgnl
        "
        class="h-100 d-flex justify-content-center"
        :class="[isSalleActive ? 'lobby_container' : '']"
      >
        <b-link
          v-if="content.typeAffichage.forcerAffichage == 'true'"
          class="stretched-link"
          :target="getTargetLobby"
          @click="
            if (isSalleActive) {
              launchBingoAndGaq();
            }
          "
        ></b-link>
        <b-link
          v-else
          :to="{ path: '/bingo/lobby', query: { idSalle: content.idSalle } }"
          class="stretched-link"
          replace
          :target="getTargetLobby"
        ></b-link>

        <div
          class="bingo_lobby_card bingo_lobby_card_dimension bingo_lobby_background d-flex flex-column justify-content-between w-100"
          :style="
            'background: linear-gradient(to bottom, #f9ffff, rgba(255,255,255,0) 50%, rgba(0,0,0,0) 70%, black 100%) no-repeat, url(' +
            jel_getFichierSrc(salle.image) +
            ') no-repeat; border-color:' +
            salle.couleurClair +
            ';'
          "
        >
          <b-row class="w-100">
            <b-col cols="4"></b-col>
            <b-col cols="8">
              <div class="bingo_lobby_titre graphik_bold text-right">{{ salle.titre }}</div>
            </b-col>
          </b-row>
          <div v-if="isSalleActive">
            <div class="w-100 text-left bingo_bold bingo_lobby_color lobby_text pl-2">
              <div v-if="salleLive.nomJeu && salleLive.nomJeu != ''">
                {{ $t('messageComponent.jeu') }} {{ salleLive.nomJeu }}
              </div>
              <div v-else>
                {{ $t('messageComponent.nomJeuIndisponible') }}
              </div>

              <span v-if="salleLive.cagnotte && salleLive.cagnotte > 0 && !isSalleSolo"
                >{{ $t('messageComponent.cagnotte') }}
              </span>
              <money-format
                v-if="salleLive.cagnotte && !isSalleSolo"
                :value="salleLive.cagnotte"
                :locale="$i18n.locale + '-CA'"
                currency-code="CAD"
                :subunit-value="true"
                class="bingo_lobby_money_format_price"
              ></money-format>

              <!-- si la salle ne contient pas de lot progressif -->
              <div
                v-if="!salleLive.grosLots || salleLive.grosLots.length == 0"
                class="bingo_lobby_color"
              >
                {{ $t('messageComponent.aucunProgressif') }}
              </div>
              <!-- si la salle contient plus d'un progressif -->
              <div v-else-if="salleLive.grosLots.length >= 1">
                {{ $t('messageComponent.progressif') }} {{ salleLive.grosLots[0].nom
                }}{{ $t('messageComponent.deuxPoints') }}
                <money-format
                  :value="Number(salleLive.grosLots[0].montant)"
                  :locale="$i18n.locale + '-CA'"
                  currency-code="CAD"
                  :subunit-value="true"
                  :hide-subunits="true"
                  class="bingo_lobby_money_format_price"
                ></money-format>
              </div>
            </div>

            <hr class="col-10 lobby_hr" :style="{ color: salle.couleurClair }" />

            <b-card-footer class="bingo_lobby_color pt-0 w-100">
              <div class="d-flex justify-content-around">
                <div v-if="isSalleSolo" class="p-0 d-flex align-items-center lobby_icon_wrapper">
                  <div class="d-flex pr-1">
                    <img
                      v-lazy="
                        `${mixinEnvironnement_damPath}/jel/bingo/icones/icon_playerSoloWhite.svg`
                      "
                      :alt="$t('messageComponent.nbJoueurs')"
                      class="bingo_icon_lobby"
                    />
                  </div>
                  <div>
                    {{ CS_NB_JOUEUR_SOLO }}
                  </div>
                </div>
                <div v-else class="p-0 d-flex align-items-center lobby_icon_wrapper">
                  <div class="d-flex pr-1">
                    <img
                      v-lazy="`${mixinEnvironnement_damPath}/jel/bingo/icones/icon_playerWhite.svg`"
                      :alt="$t('messageComponent.nbJoueurs')"
                      class="bingo_icon_lobby"
                    />
                  </div>
                  <div>
                    {{ salleLive.nombreJoueurs }}
                  </div>
                </div>

                <div
                  v-if="!isSalleSolo"
                  class="p-0 d-flex align-items-center lobby_clock_icon_wrapper"
                >
                  <div class="d-flex pr-1">
                    <img
                      v-lazy="`${mixinEnvironnement_damPath}/jel/bingo/icones/icon_clockWhite.svg`"
                      :alt="$t('messageComponent.temps')"
                      class="bingo_icon_lobby"
                    />
                  </div>
                  <div>
                    <CompteARebours :dateHeureFin="salleLive.debutTirage"> </CompteARebours>
                  </div>
                </div>
                <div class="p-0 d-flex align-items-center lobby_icon_wrapper">
                  <div class="d-flex pr-1">
                    <img
                      v-lazy="`${mixinEnvironnement_damPath}/jel/bingo/icones/icon_ballsWhite.svg`"
                      :alt="$t('messageComponent.boules')"
                      class="bingo_icon_lobby"
                    />
                  </div>
                  <div>
                    {{ salleLive.nombreBoules }}
                  </div>
                </div>
                <div class="p-0 d-flex align-items-center lobby_card_icon_wrapper">
                  <div class="d-flex pr-1">
                    <img
                      v-lazy="
                        `${mixinEnvironnement_damPath}/jel/bingo/icones/icon_priceCardWhite.svg`
                      "
                      :alt="$t('messageComponent.prixCarte')"
                      class="bingo_icon_lobby"
                    />
                  </div>
                  <div>
                    <div class="d-flex justify-content-center">
                      <money-format
                        :value="salleLive.prixCarteMin"
                        :locale="$i18n.locale + '-CA'"
                        currency-code="CAD"
                        :subunit-value="true"
                      ></money-format>
                      <div v-if="salleLive.prixCarteMin != salleLive.prixCarteMax" class="pl-1">
                        -
                      </div>
                    </div>
                    <div v-if="salleLive.prixCarteMin != salleLive.prixCarteMax">
                      <money-format
                        :value="salleLive.prixCarteMax"
                        :locale="$i18n.locale + '-CA'"
                        currency-code="CAD"
                        :subunit-value="true"
                      ></money-format>
                    </div>
                  </div>
                </div>
              </div>
            </b-card-footer>
          </div>
          <div v-else class="w-100 text-center bingo_bold bingo_lobby_color lobby_text_fermer mb-4">
            {{ messageTitreSalleDesactivation }}
          </div>
        </div>
      </div>
    </div>

    <!-- ******************************** -->
    <!-- ***** DETAIL (page Salles) ***** -->
    <!-- ******************************** -->
    <div
      v-else-if="content.typeAffichage.field === 'detail'"
      class="pt-2 pb-5"
      data-component-page="salles.page-salles"
      :data-tag="`${jel_getNomRouteCourante()} - ${salle.titre.replace(/&nbsp;/g, ' ')} - ${
        content.dataTag
      }`"
    >
      <b-row class="mx-n2">
        <b-col
          class="col-12 col-md-5 bingo_salle_col_mobile bingo_salle_col_mobile_img_container d-flex flex-column justify-content-md-end"
        >
          <!-- titre -->
          <div class="bingo_affichage_mobile">
            <div class="bingo_detail_titre graphik_bold">{{ salle.titre }}</div>
            <!-- hr thick moitié du titre -->
            <hr class="bingo_detail_underline_titre" :style="{ color: salle.couleurClair }" />
          </div>
          <!-- img dans img description -->
          <div class="bingo_position_relative">
            <p class="bingo_descp_over d-none d-md-block graphik_semibold">{{ salle.slogan }}</p>
            <b-img-lazy
              :src="jel_getFichierSrc(salle.image)"
              :alt="salle.titre"
              class="img-fluid bingo_detail_img_salle"
            ></b-img-lazy>
          </div>
        </b-col>
        <b-col class="col-12 col-md-7 bingo_salle_col_mobile">
          <b-card
            class="bingo_card_corner bingo_card_salle ctn-shadow bingo_card_corner_mobile bingo_card_background overflow-hidden"
          >
            <b-row v-if="isSalleActive" class="bingo_row_height no-gutters w-100">
              <b-col class="col-9 col-xl-10">
                <b-container class="h-100 d-flex flex-column py-0 px-1">
                  <b-row class="entete_salle_min_height">
                    <b-col class="col-12 d-flex align-items-center">
                      <!-- si la salle ne contient pas de lot progressif -->
                      <div v-if="!salleLive.grosLots || salleLive.grosLots.length == 0">
                        <div
                          class="bingo_progressif bingo_progressif_salles graphik_semibold"
                          :style="{ color: salle.couleurFonce }"
                        >
                          {{ $t('messageComponent.aucunProgressif') }}
                        </div>
                      </div>
                      <!-- si la salle contient plus d'un lot on affiche uniquement les deux premiers  -->
                      <div v-else>
                        <div
                          v-for="(n, i) in Math.min(
                            salleLive.grosLots.length,
                            nbrProgressifAffichageSalle
                          )"
                          :key="i.id"
                          class="mb-1"
                          :class="[i > 0 ? 'd-none d-md-block' : '']"
                        >
                          <div class="d-flex align-items-center">
                            <div
                              class="bingo_progressif bingo_progressif_salles graphik_semibold"
                              :style="{ color: salle.couleurFonce }"
                            >
                              {{ $t('messageComponent.progressif') }}
                              {{ salleLive.grosLots[i].nom }}
                            </div>
                            <div
                              v-if="
                                i == 0 && salleLive.grosLots.length > nbrProgressifAffichageSalle
                              "
                              class="inline ml-1 autre_lots_container"
                            >
                              <div
                                class="btn_autre_lot"
                                @click="isAfficherAutreLot = !isAfficherAutreLot"
                              >
                                <b-img-lazy
                                  :src="`${mixinEnvironnement_damPath}${getPlusIcon}`"
                                  alt="Plus"
                                  class="h-100 img_autres_lots py-1"
                                >
                                </b-img-lazy>
                                <div v-show="isAfficherAutreLot" class="bingo_autre_lots">
                                  <div
                                    v-for="(n, i) in salleLive.grosLots.length -
                                    nbrProgressifAffichageSalle"
                                    :key="i.id"
                                    class="d-flex flex-column text-left pb-1"
                                  >
                                    <div class="autre_lots_nom_progressif graphik_semibold">
                                      {{ $t('messageComponent.progressif') }}
                                      {{ salleLive.grosLots[i + nbrProgressifAffichageSalle].nom }}
                                    </div>
                                    <money-format
                                      :value="
                                        Number(
                                          salleLive.grosLots[i + nbrProgressifAffichageSalle]
                                            .montant
                                        )
                                      "
                                      :locale="$i18n.locale + '-CA'"
                                      currency-code="CAD"
                                      :subunit-value="true"
                                      :hide-subunits="true"
                                      class="graphik_bold"
                                    ></money-format>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="bingo_progressif_lot graphik_bold">
                            <money-format
                              :value="Number(salleLive.grosLots[i].montant)"
                              :locale="$i18n.locale + '-CA'"
                              currency-code="CAD"
                              :subunit-value="true"
                              :hide-subunits="true"
                              class="bingo_prix bingo_color"
                            ></money-format>
                          </div>
                        </div>
                      </div>
                    </b-col>

                    <b-col class="bingo_anim_position col-md-3 col-sm-12 d-flex"> </b-col>
                  </b-row>
                  <hr class="bingo_border_separateur my-1" />
                  <b-row class="text-left salle_col_height flex-grow-1">
                    <b-container
                      class="h-100 d-flex justify-content-between flex-column flex-grow-1 py-0"
                    >
                      <div class="ml-2">
                        <ul class="bingo_liste_type_jeu bingo_color">
                          <li v-if="salleLive.nomJeu && salleLive.nomJeu != ''" class="bingo_bold">
                            {{ $t('messageComponent.jeu') }} {{ salleLive.nomJeu }}
                          </li>
                          <li v-else class="bingo_bold">
                            {{ $t('messageComponent.nomJeuIndisponible') }}
                          </li>

                          <li v-if="salleLive.cagnotte && salleLive.cagnotte > 0 && !isSalleSolo">
                            <span class="bingo_bold">{{ $t('messageComponent.cagnotte') }}</span>
                            <money-format
                              :value="salleLive.cagnotte"
                              :locale="$i18n.locale + '-CA'"
                              currency-code="CAD"
                              :subunit-value="true"
                              class="bingo_cagnotte"
                            ></money-format>
                          </li>

                          <li v-else-if="!isSalleSolo">
                            <span class="bingo_bold">{{ $t('messageComponent.cagnotte') }}</span>
                            <money-format
                              :value="0"
                              :locale="$i18n.locale + '-CA'"
                              currency-code="CAD"
                              :subunit-value="true"
                              :hide-subunits="true"
                              class="bingo_cagnotte"
                            ></money-format>
                          </li>
                        </ul>
                        <!-- liste de la description du jeu -->
                        <span
                          class="bingo_color bingo_liste_type_jeu"
                          v-html="salle.description"
                        ></span>
                      </div>

                      <a class="pt-1 pt-md-0" @click="launchBingoAndGaq()">
                        <!-- 'important' à cause d'un style main-bingo qui a un ':hover' qui met le bouton blanc -->
                        <button
                          class="btn bingo_bouton_border btn_detail_hover p-1 graphik_bold mb-0"
                          :style="{ 'background-color': salle.couleurClair + ' !important' }"
                          :data-tag="`${jel_getNomRouteCourante()} - ${salle.titre.replace(
                            /&nbsp;/g,
                            ' '
                          )} - ${content.dataTag}`"
                        >
                          {{ $t('jouer') }}
                        </button>
                      </a>
                    </b-container>
                  </b-row>
                </b-container>
              </b-col>

              <b-col class="p-sm-0 py-1 col-3 col-sm-2 offset-sm-1 col-md-3 offset-md-0 col-xl-2">
                <!-- temps personne boule prix de la carte tous un en dessous de lautre -->
                <b-row class="h-100 no-gutters d-flex align-content-center detail_icon_container">
                  <div class="bingo_container_info_courte bingo_card_corner card">
                    <div class="card-body h-100 d-flex flex-column justify-content-center">
                      <div class="bingo_salle_detail_icon_placement">
                        <div v-if="isSalleSolo" class="bingo_salle_detail_icon_col">
                          <img
                            v-lazy="
                              `${mixinEnvironnement_damPath}/jel/bingo/icones/icon_playerSolo.svg`
                            "
                            :alt="$t('messageComponent.nbJoueurs')"
                            class="bingo_icon_detail"
                          />
                          <br />
                          <span class="bingo_detail_icon_text">{{ CS_NB_JOUEUR_SOLO }}</span>
                        </div>
                        <div v-else class="bingo_salle_detail_icon_col">
                          <img
                            v-lazy="
                              `${mixinEnvironnement_damPath}/jel/bingo/icones/icon_player.svg`
                            "
                            :alt="$t('messageComponent.nbJoueurs')"
                            class="bingo_icon_detail"
                          />
                          <br />
                          <span class="bingo_detail_icon_text">{{ salleLive.nombreJoueurs }}</span>
                        </div>

                        <div v-if="!isSalleSolo" class="bingo_salle_detail_icon_col">
                          <img
                            v-lazy="`${mixinEnvironnement_damPath}/jel/bingo/icones/icon_clock.svg`"
                            :alt="$t('messageComponent.temps')"
                            class="bingo_icon_detail"
                          />
                          <br />
                          <span class="bingo_detail_icon_text">
                            <CompteARebours :dateHeureFin="salleLive.debutTirage"></CompteARebours>
                          </span>
                        </div>
                        <div class="bingo_salle_detail_icon_col">
                          <img
                            v-lazy="`${mixinEnvironnement_damPath}/jel/bingo/icones/icon_balls.svg`"
                            :alt="$t('messageComponent.boules')"
                            class="bingo_icon_detail"
                          />
                          <br />
                          <span class="bingo_detail_icon_text">{{ salleLive.nombreBoules }}</span>
                        </div>
                        <div class="bingo_salle_detail_icon_col">
                          <img
                            v-lazy="
                              `${mixinEnvironnement_damPath}/jel/bingo/icones/icon_priceCard.svg`
                            "
                            :alt="$t('messageComponent.prixCarte')"
                            class="bingo_icon_detail"
                          />
                          <br />
                          <div class="bingo_detail_icon_text">
                            <div class="d-flex justify-content-center">
                              <money-format
                                :value="salleLive.prixCarteMin"
                                :locale="$i18n.locale + '-CA'"
                                currency-code="CAD"
                                :subunit-value="true"
                              ></money-format>
                              <div
                                v-if="salleLive.prixCarteMin != salleLive.prixCarteMax"
                                class="pl-1"
                              >
                                -
                              </div>
                            </div>
                            <div v-if="salleLive.prixCarteMin != salleLive.prixCarteMax">
                              <money-format
                                :value="salleLive.prixCarteMax"
                                :locale="$i18n.locale + '-CA'"
                                currency-code="CAD"
                                :subunit-value="true"
                              ></money-format>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-row>
              </b-col>
            </b-row>

            <!-- Salle désactivée -->
            <b-row v-else class="bingo_row_height no-gutters w-100 h-100">
              <b-col
                cols="12"
                class="bingo_titre_salle d-flex flex-column justify-content-around pr-4"
              >
                <div
                  class="container detail_message_fermeture_container text-left my-3 my-md-0 d-flex flex-column align-items-start"
                >
                  <div
                    class="detail_message_fermeture_surtitre graphik_bold pb-2"
                    :style="{ color: salle.couleurFonce }"
                  >
                    {{ messageTitreSalleDesactivation }}
                  </div>
                  <div class="detail_message_fermeture">
                    {{ messageSousTitreSalleDesactivation }}
                  </div>
                </div>
                <b-card
                  class="bingo_message_heure_ouverture_salle"
                  :style="{ 'background-color': salle.couleurClair }"
                  >{{ messageRetour }}</b-card
                >
              </b-col>
              <div class="ml-3">
                <!-- liste de la description du jeu -->
                <span
                  class="bingo_color bingo_liste_type_jeu text-left"
                  v-html="salle.description"
                ></span>
                <b-col class="col-12 mt-5 text-left">
                  <div
                    class="bingo_liste_type_jeu bingo_color container"
                    v-html="messageDescriptionSalleDesactivation"
                  ></div>
                </b-col>
              </div>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */

import { mapGetters } from 'vuex';
import MoneyFormat from 'vue-money-format';
import moment from 'moment-timezone';

// Components
import CompteARebours from '../base/CompteARebours.vue';

// Helpers
import { registerVendorListenerConsent } from '@/helpers/ConsentHelpers';
import { PageMapping } from '@/helpers/PageMappingHelpers';

// Mixins
import { mixinEnvironnement } from '@/mixins/mixinEnvironnement';

// Services
import session from '@/services/api/compte/session';

export default {
  name: 'BingoSalle',
  components: {
    'money-format': MoneyFormat,
    CompteARebours,
  },
  mixins: [mixinEnvironnement],
  props: { content: { type: Object, required: true } },
  data() {
    return {
      isAfficherAutreLot: false,
    };
  },
  i18n: {
    // `i18n` option, setup locale info for component
    messages: {
      fr: {
        messageComponent: {
          boules: 'Nombre de boules',
          deRetourA: 'De retour à',
          deRetourBientot: 'De retour bientôt',
          nbJoueurs: 'Nombre de joueurs',
          temps: 'Temps',
          jeu: 'Jeu :',
          cagnotte: 'Cagnotte :',
          prixCarte: 'Prix carte',
          nomJeuIndisponible: 'Nom du jeu indisponible',
          progressif: 'Progressif',
          aucunProgressif: 'Aucun lot progressif',
          deuxPoints: ' :',
        },
      },
      en: {
        messageComponent: {
          boules: 'Number of balls',
          deRetourA: 'We will be back at',
          deRetourBientot: 'We will be back soon',
          nbJoueurs: 'Players number',
          temps: 'Time',
          jeu: 'Game:',
          cagnotte: 'Jackpot:',
          prixCarte: 'Card price',
          nomJeuIndisponible: 'Game name unavailable',
          progressif: 'Jackpot',
          aucunProgressif: 'No Jackpot',
          deuxPoints: ':',
        },
      },
    },
  },
  computed: {
    CS_NB_JOUEUR_SOLO: () => 1,

    ...mapGetters('bingo', ['getSalle', 'getSalleLive']),

    salle() {
      return this.getSalle(this.content.idSalle);
    },
    salles() {
      return this.getSalle(null);
    },
    salleLive() {
      return this.getSalleLive(this.salle.idSalleNyx);
    },
    isSalleCourante() {
      return (
        this.$route.query.salleId != undefined && this.$route.query.salleId == this.content.salleId
      );
    },
    isSalleSolo() {
      return this.salle?.indSolo === 'true';
    },
    isSalleActive() {
      return this.isActif && this.isOuverte;
    },
    isActif() {
      if (this.salle) {
        const maintenant = moment();
        let debut = null;
        let fin = null;

        if (this.salle.dateDebutDesactivation != undefined) {
          debut = moment(this.salle.dateDebutDesactivation);
        }
        if (this.salle.dateFinDesactivation != undefined) {
          fin = moment(this.salle.dateFinDesactivation);
        }

        if (debut == null && (fin == null || maintenant.isAfter(fin))) {
          return true;
        }
        if (fin == null && (debut == null || maintenant.isBefore(debut))) {
          return true;
        }
        if (maintenant.isBefore(debut) || maintenant.isAfter(fin)) {
          return true;
        }
        return false;
      }
      // Inactif par defaut. (S'il y a une erreur et que la salle retourne aucune information)
      return false;
    },
    isOuverte() {
      return this.salleLive?.ouvert === true;
    },
    lobbyLinkRoute() {
      return this.$store.getters['routes/getRouteByPath']('/jel/bingo/lobby');
    },

    getTargetLobby() {
      // Si le lobby est ouvert, on demeure dans la fenêtre courante
      return this.$route.fullPath.indexOf('/lobby') == -1 ? '_blank' : '';
    },
    getPlusIcon() {
      if (this.isAfficherAutreLot) {
        return '/jel/bingo/salles/ic_close.svg';
      }
      return '/jel/bingo/salles/ic_more.svg';
    },
    nbrProgressifAffichageSalle() {
      if (this.$mq == 'sm') {
        return 1;
      }
      return 2;
    },
    // À RETIRER 2023-13-15
    // areTablesActives() {
    //   return this.isActif(this.salles);
    // },
    messageRetour() {
      if (this.salle.msgDeRetour) {
        return this.salle.msgDeRetour;
      }
      let dateFin = this.salle.dateFinDesactivation;
      // À RETIRER 2023-13-15
      // if (!this.areTablesActives) {
      //   dateFin = this.salles.dateFinDesactivation;
      // }
      let isFormatDate = true;
      if (this.salle.isActif) {
        // Salle fermer
        dateFin = this.salle.heureOuverture;
        isFormatDate = false;
      }
      return `${this.getFormatMessageRetour(dateFin, isFormatDate)}.`;
    },
    messageTitreSalleDesactivation() {
      return this.getSalleDesactivationMessage('titre');
    },
    messageSousTitreSalleDesactivation() {
      return this.getSalleDesactivationMessage('sousTitre');
    },
    messageDescriptionSalleDesactivation() {
      return this.getSalleDesactivationMessage('description');
    },
  },
  created() {
    this.$store.dispatch('bingo/initSalles');
  },
  updated() {
    if (session.sessionEstOuverte()) {
      const idSalle = sessionStorage.getItem('idSalle');
      if (idSalle && !/bingo\/lobby/.test(window.location.pathname)) {
        if (!/anon/i.test(ejConnect.etatClient)) {
          if (/(ci|cl)/i.test(ejConnect.etatClient)) {
            this.ouvrirModaleConfirmationCICL();
          } else {
            this.launchBingoAndGaq(idSalle);
          }
        }
      }
    }
  },
  methods: {
    launchBingoAndGaq(salleId = null) {
      const idSalle = salleId ?? this.content.idSalle;
      if (!session.sessionEstOuverte()) {
        /*
         * On ajoute 'idSalle' dans le sessionStorage
         * pour lancer automatiquement la Salle de Bingo après le login
         */
        // On test si le bouton de connexion Auth0 est actif
        if (process.env.VUE_APP_CIAM_ENABLED === 'true') {
          sessionStorage.setItem('idSalle', idSalle);
          // eslint-disable-next-line no-undef
          lancerConnexionAuth0(this.$i18n.locale, window.location.href);
        } else {
          // eslint-disable-next-line no-undef
          ejConnect.ouvrirModaleLogin();
        }
      } else if (/(ci|cl)/i.test(ejConnect.etatClient)) {
        this.ouvrirModaleConfirmationCICL();
      } else {
        this.ouvrirSalleBingo(idSalle);
      }
    },
    ouvrirSalleBingo(idSalle) {
      if (idSalle) {
        // Ajout event vers GTM
        this.gtmTrackEvent(idSalle);
        /*
         * On supprime 'idSalle' du sessionStorage
         * pour ne pas lancer deux fois la Salle de Bingo
         */
        sessionStorage.removeItem('idSalle');

        // URL du lobby Bingo
        const url = `/${this.$i18n.locale}${this.lobbyLinkRoute['@path']}?idSalle=${idSalle}`;

        if (!this.isRedirigeNouvelleFenetre()) {
          /**
           * On catch le 'router.push()' pour éviter une erreur du type:
           * Uncaught (in promise)
           * Error: Problem handling something:
           * Error: Redirected when going from "?" to "?" via a navigation guard.
           * */
          this.$router
            .push({
              path: PageMapping.BINGO_LOBBY.siteUrl,
              query: { idSalle },
            })
            .catch((err) => {});
          return;
        }
        // Ouverture dans une et une seule fenêtre (nom=Bingo)
        this.jel_ouvrirFenetre(url, 'Bingo', 'yes', 'yes', 'no');
      }
    },
    gtmTrackEvent(idSalle) {
      // eslint-disable-next-line camelcase
      if (typeof custom_trackEvent == 'function') {
        // On vérifie le consentement avant de pousser l'event vers GTM (Cf. loi 25)
        registerVendorListenerConsent(
          process.env.VUE_APP_IAB_ID_ANALYTICS,
          function () {
            // GTM track event lancement Salle Bingo
            custom_trackEvent('EJ : Jouer', 'Argent Réel', idSalle);
          },
          function () {
            console.log('Pas de consentement, aucun event ne sera envoyé vers GTM !');
          }
        );
      }
    },
    isRedirigeNouvelleFenetre() {
      // Separe la logique pour déterminer si on ouvre le jeu dans un nouvel onglet
      // Utilise présentement la logique de la taille du device
      return window.matchMedia('(min-device-width: 960px)').matches;
    },
    getFormatMessageRetour(dateFin, isFormatDate) {
      if (dateFin != null) {
        if (isFormatDate) {
          dateFin = this.getHeureSiDansProchainJour(dateFin);
        }
        if (dateFin != null) {
          return `${this.$i18n.t('messageComponent.deRetourA')} ${this.formatHeure(
            dateFin,
            'America/Toronto'
          )}`;
        }
      }
      return this.$i18n.t('messageComponent.deRetourBientot');
    },
    getSalleDesactivationMessage(property) {
      const propFermer = 'Fermeture';
      const propDesact = 'Desactivation';
      let currentProp = property;
      if (this.salle.isActif) {
        currentProp += propFermer;
        return this.salle[currentProp];
      }
      currentProp += propDesact;
      // À RETIRER 2023-13-15
      // if (!this.areTablesActives) {
      //   // TODO: Valider si on utilise la valeur du parent pour toutes les propriétés dans cette situation.
      //   // Sinon passer un flag en paramètre
      //   return this.salles[currentProp];
      // }
      return this.salle[currentProp];
    },
    getHeureSiDansProchainJour(dateFin) {
      const momentDateFin = moment(dateFin);
      if (momentDateFin.isValid()) {
        const maintenant = moment();
        const lendemain = moment().add(1, 'd');
        if (momentDateFin.isBetween(maintenant, lendemain)) {
          return `${momentDateFin.get('hours')}:${momentDateFin.get('minutes')}`;
        }
      }
      return null;
    },
    formatHeure(heure, timeZone) {
      const momentHeure = moment.tz(heure, 'HH:mm', timeZone);

      // Si l'heure est invalide, ne retournez rien
      if (!momentHeure.isValid()) {
        return '';
      }

      // Conversion d’heure d'un fuseau horaire en heure client
      if (this.mixinLangue_langue == 'en') {
        const periode = momentHeure.tz(moment.tz.guess()).format('a') == 'am' ? ' a.m.' : ' p.m.';
        return momentHeure.tz(moment.tz.guess()).format('h:mm') + periode;
      }
      return momentHeure.format('m') == 0
        ? `${momentHeure.tz(moment.tz.guess()).format('H')} h`
        : `${momentHeure.tz(moment.tz.guess()).format('H')} h ${momentHeure.format('mm')}`;
    },
    ouvrirModaleConfirmationCICL() {
      // On supprime 'idSalle' du sessionStorage pour ne pas ouvrir plusieurs fois la modale de confirmation
      sessionStorage.removeItem('idSalle');
      this.$bvModal.show('modale-confirmation-ci-cl');
    },
  },
};
</script>

<style lang="scss" scoped>
.row {
  background-position: center;
  background-repeat: no-repeat;
}
.row.bgcover {
  background-size: cover;
}
.container-fluid {
  padding: 0;
}

.card {
  background-color: transparent;
}

.card-body {
  padding: 0;
}

.bingo_div_height a {
  text-decoration: none;
}

.bingo_progressif {
  text-align: left;
  color: black;
}

// pour l'affichage pastille
.bingo_progressif_pastille {
  @include ms-respond(font-size, 0);
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.bingo_progressif_salles {
  @include ms-respond(font-size, 1);
}

.bingo_progressif_lot {
  text-align: left;
  color: black;
  @include ms-respond(font-size, 1);
}

.bingo_progressif_lot_accueil {
  text-align: left;
  color: black;
  @include ms-respond(font-size, 0);
}

.bingo_prix {
  @include ms-respond(font-size, 1);
}

.bingo_div_img_principal {
  height: 100%;
  width: 100%;
}

.autre_lots_container {
  z-index: 1;
}

.img_autres_lots {
  z-index: 1;
}

.bingo_autre_lots {
  background: rgba(255, 255, 255, 0.95);
  position: absolute;
  border: solid 1px #25d09a;
  border-radius: ms(1);
  z-index: -1;
  top: 0;
  padding-top: 5rem;
  margin-left: -1rem;
  margin-top: -1rem;
  padding-left: 2rem;
  padding-right: 2rem;
  padding-bottom: 1rem;
  width: fit-content;
  width: -moz-max-content;
}

.autre_lots_nom_progressif {
  color: #808080;
}

.bingo_pastille_row_footer {
  border-bottom-right-radius: ms(1);
  border-bottom-left-radius: ms(1);
  @include ms-respond(font-size, -1);
  height: 29%;
}

@include media-breakpoint-down(xxl) {
  .bingo_pastille_row_footer {
    height: 25%;
  }
}

@include media-breakpoint-down(sm) {
  .bingo_pastille_row_footer {
    @include ms-respond(font-size, 0);
  }
}

.bingo_card_salle {
  padding: 3% 1% 3% 3%;
}

.detail_icon_container {
  padding: 0 5%;
}

.bingo_card_corner {
  border-radius: 1.5rem;
  height: 100%;
  width: 100%;
}

.bingo_container_over_price {
  display: flex;
  justify-content: flex-end;
  right: -5%;
}

.bingo_container_over {
  position: absolute;
  display: flex;
  top: -26px;
  background-color: #303030;
  color: white;
  font-weight: bold;
  border-radius: 8px;
  @include ms-respond(font-size, 0);
  padding: 2%;
  -webkit-box-shadow: 1px 1px 5px 0px #555;
  box-shadow: 1px 1px 5px 0px #555;
}

.bingo_titre {
  @include ms-respond(font-size, 4);
  font-family: graphik_bold;
  color: black;
  position: absolute;
  border-style: none;
  background-color: transparent;
  text-align: left;
  font-weight: bold;
  margin-left: 4%;
  margin-top: 1%;
  line-height: 1.5;
}

// rajouter du pading pour faire fiter comme ils veulent
.bingo_msg_desactivation {
  @include ms-respond(font-size, 0);
  height: 60%;
  text-align: center;
}

.bingo_message_heure_ouverture {
  @include ms-respond(font-size, 0);
  font-weight: bold;
  height: 40%;
  text-align: center;
}

.bingo_fermer_titre_img {
  opacity: 0.5;
}

.bingo_pastille_row {
  height: 10rem;
  padding-top: 5%;
}

.bingo_pastille_row_txt {
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  height: 75%;
}
.bingo_row_height {
  height: 100%;
}

.entete_salle_min_height {
  min-height: 3.75rem;
}

.bingo_div_height {
  line-height: 1.2;
  // padding-bottom: 1rem;
  width: 100%;
}

.bingo_container_info_courte {
  background-color: #f0f0f0;
  height: 100%;
  border: none;
}

.bingo_detail_titre {
  text-align: left;
  @include ms-respond(font-size, 6);
  font-weight: 900;
  color: black;
}

.bingo_img_principal {
  border-top-left-radius: ms(1);
  border-top-right-radius: ms(1);
  height: 100%;
}
.bingo_cagnotte {
  display: inline;
  font-weight: bold;
}

.bingo_detail_underline_titre {
  margin: 0;
  border: 6px solid;
  width: ms(11);
  margin-bottom: 3%;
}

.bingo_descp_over {
  position: absolute;
  //top:ms(8);
  padding-left: 4%;
  padding-right: 4%;
  margin-top: 3%;
  @include ms-respond(font-size, 2);
  font-weight: 900;
  color: black;
  text-align: left;
}

.bingo_bouton_border {
  border-radius: 40px;
  @include ms-respond(font-size, 1);
  font-weight: bold;
  text-transform: uppercase;
  width: 125px;
  height: 46px;
  color: black;
}

.btn_detail_hover:hover {
  opacity: 0.5;
}

bingo_titre_salle {
  .detail_message_fermeture_container {
    .detail_message_fermeture {
      color: #707070;
    }
  }
}

.bingo_message_heure_ouverture_salle {
  // position: absolute;
  position: relative;
  width: 108%; // je peux étiré plus en mettant le width a 110 ou 120 %, mais il faut déplacer la boîte plus a gauche (pourcentage neg) pcq l'étirement ce fait juste a droite
  // top: 50%;
  left: -5%;
  @include ms-respond(font-size, 1);
  font-weight: bold;
  border: none;
  padding: 1% 5%;
  color: black;
  text-align: center;
}

.bingo_img_titre {
  width: 100%;
  height: 75%;
}

.bingo_card_background {
  background-color: #ffffff;
}

.cursor_pointer {
  cursor: pointer;
}

.glow_card {
  transition: all 0.2s ease-in-out;
}

.glow_card:hover {
  color: rgba(255, 255, 255, 1);
  box-shadow: 1px 1px 13px 0px #4a4949;
}

.bingo_border_separateur {
  border: 1px solid whitesmoke;
  width: 100%;
}

.bingo_anim_position {
  align-self: center;
}

.anim_container {
  width: 6rem;
}

.bingo_liste_type_jeu {
  margin-bottom: 0;
  font-size: ms(0);
  line-height: 1.3;
}
.bingo_bold {
  font-weight: bold;
}

.bingo_detail_img_salle {
  width: 100%;
}
.bingo_icon {
  margin-right: 4px;
  width: 39%;
}
.bingo_icon_wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
}
.bingo_clock_icon_wrapper {
  align-items: center;
  display: flex;
  //justify-content: center;
}
.bingo_icon_detail {
  width: 50%;
}

.lobby_icon_wrapper {
  flex: 0 0 20%;
}

.lobby_clock_icon_wrapper {
  flex: 0 0 35%;
}

.lobby_card_icon_wrapper {
  flex: 0 0 25%;
}

.bingo_icon_lobby {
  // width: 25%;
  @include ms-respond(width, 2);
  color: white;
  height: 100%;
}
.bingo_pastille_acceuil {
  height: 88%;
}

.bingo_salle_detail_icon_col {
  flex: none;
  max-width: none;
}

.bingo_acceuil_div {
  margin: -1px;
  height: 100%;
}

.bingo_salle_detail_icon_placement {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  height: 100%;
  max-height: 22rem;
  text-align: center;
}

.bingo_color {
  color: black;
}
.bingo_detail_icon_text {
  font-weight: 900;
  color: black;
  @include ms-respond(font-size, -1);
}

.bingo_salle_fermer {
  border: 2px solid #efefef;
  overflow: hidden;
}

.lobby_container {
  cursor: pointer;
}

.bingo_lobby_card {
  border: 0.3rem solid;
  border-radius: ms(2);
  padding-top: 0.5rem;
}

.bingo_lobby_card_dimension {
  height: 14.5rem;
  width: 22rem;
}

.bingo_lobby_img {
  border-radius: ms(2);
}

.bingo_lobby_titre {
  font-size: ms(3);
  color: black;
  font-weight: 900;
  min-height: 5rem;
}

.bingo_lobby_color {
  color: white;
  font-size: ms(-1);
}

.lobby_hr {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  border: 1px solid rgb(255, 255, 255);
}

.bingo_lobby_money_format_price {
  display: inline;
  font-weight: 900;
}

.bingo_lobby_background {
  background-size: 100% 100% !important;
  background-position: 100% -50px !important;
  background-color: black !important;
}

.bingo_row_img_pastille {
  height: 60%;
}

.inline {
  display: inline;
}
.btn_autre_lot {
  color: black;
  height: 3rem;
  @include ms-respond(font-size, 0);
}

.salle_col_height {
  height: auto;
  display: flex;
  flex-direction: column;
  justify-items: space-between;
  min-height: 12.5rem;
}

.detail_message_fermeture_surtitre {
  font-size: 1.2rem;
}

@include media-breakpoint-up(xl) {
  .detail_message_fermeture_surtitre {
    font-size: 1.35rem;
  }
}

@include media-breakpoint-down(sm) {
  .bingo_affichage_mobile {
    position: absolute;
    z-index: 1;
    margin-top: 2%;
    margin-left: 2%;
  }
  .bingo_position_relative {
    position: relative;
    height: 100%;
  }
}

@include media-breakpoint-up(md) {
  .bingo_detail_img_salle {
    border-radius: ms(1);
  }
}

@include media-breakpoint-down(sm) {
  .bingo_salle_col_mobile {
    padding: 0;
  }

  .bingo_salle_col_mobile_img_container {
    height: 12rem;
  }

  .bingo_detail_img_salle {
    height: 100%;
    object-fit: cover;
    object-position: top;
  }

  .bingo_card_corner_mobile {
    border-radius: 0;
  }
}

@include media-breakpoint-down(sm) {
  .bingo_lobby_card_dimension {
    height: 14.5rem;
    width: 100%;
  }
}

::v-deep ul li {
  display: list-item;
  list-style: disc;
}

.main-bingo {
  div {
    line-height: 1.2;

    .lobby_text {
      line-height: 1.4;
    }

    .lobby_text_fermer {
      font-size: ms(1);
    }

    .bingo_salle_detail_icon_col {
      line-height: 0.5;
    }
  }

  .container-fluid {
    padding: 0;
  }

  .container {
    padding: 0 15px;
  }
}
</style>
